import React, { useState, useEffect } from 'react';
import { DndContext, closestCenter, PointerSensor, useSensor, useSensors } from '@dnd-kit/core';
import { arrayMove, SortableContext, useSortable, verticalListSortingStrategy } from '@dnd-kit/sortable';
import { CSS } from '@dnd-kit/utilities';
import { Input, Drawer, Checkbox } from 'antd';
import { HolderOutlined, SettingOutlined, CaretDownOutlined } from '@ant-design/icons';
import '../style.scss';

// Sortable Item Component
const SortableItem = ({ item, index, colDefs, setColDefs, filteredColDefs, searchValue }: any) => {
  const { attributes, listeners, setNodeRef, transform, transition, isDragging } = useSortable({ id: item.field.toString() });

  const style: React.CSSProperties = {
    transform: CSS.Transform.toString(transform),
    transition,
    opacity: isDragging ? 0.7 : 1,
    background: isDragging ? '#fafafa' : undefined,
  };

  return (
    <li
      ref={setNodeRef}
      style={style}
      {...attributes}
      {...listeners}
      className={`one-op ${item.headerName === 'Hành động' || item.hide ? 'd-none' : ''} ${!item.hide ? 'active' : ''} ${searchValue ? filteredColDefs.some((x: any) => x.field === item.field) ? '' : 'hidden-x' : ''}`}
    >
      <HolderOutlined className="icon" />
      <div className="text">
        <Checkbox
          className="one-add-filter-content"
          checked={!item.hide}
          onChange={(e: any) => {
            const findData = colDefs.find((x: any) => x.field === item.field)
            findData.hide = !e.target.checked
            setColDefs([...colDefs])
          }}
        >
          <div className="label">{item.headerName || 'check'}</div>
        </Checkbox>
      </div>
    </li>
  );
};

const ColSettingV2 = ({ stData = {} as any, stChange = (data: any, type: any) => { }, tableColDefs = [] as any }) => {
  const [colDefs, setColDefs] = useState<any[]>([]);
  const [showDrawer, setShowDrawer] = useState(false);
  const [searchValue, setSearchValue] = useState('');

  useEffect(() => {
    setColDefs([...tableColDefs || []]);
  }, [tableColDefs]);

  // Remove Vietnamese accents for search
  const removeVietnameseTones = (str: string) => {
    return str
      .normalize('NFD')
      .replace(/[\u0300-\u036f]/g, '')
      .replace(/đ/g, 'd')
      .replace(/Đ/g, 'D');
  };

  const filteredColDefs = colDefs.filter((item: any) =>
    removeVietnameseTones(item.headerName || '')
      .toLowerCase()
      .includes(removeVietnameseTones(searchValue).toLowerCase())
  );

  // dnd-kit sensors
  const sensors = useSensors(
    useSensor(PointerSensor, {
      activationConstraint: {
        distance: 5,
      },
    })
  );

  // Xử lý sắp xếp lại sau khi drag
  const handleDragEnd = (event: any) => {
    const { active, over } = event;
    if (active && over && active.id !== over?.id) {
      const oldIndex = colDefs.findIndex((item) => item.field.toString() === active.id);
      const newIndex = colDefs.findIndex((item) => item.field.toString() === over.id);
      const newArr = arrayMove(colDefs, oldIndex, newIndex);
      setColDefs(newArr);
    }
  };

  const [groupOpen, setGroupOpen] = useState({
    group1: true,
    group2: false,
  });

  return (
    <Drawer title="Basic Drawer" onClose={() => stChange({}, 'close')} open={stData?.showSetting}>
      <div className="filter-setting">
        <div className="title-add-filter">
          <span>Nâng cao</span>
        </div>
        <div className="content-filter-setting t-scrollbar">
          <div className="title-content">Tùy chỉnh trường hiển thị trên bảng</div>
          <div className='input-filter-header'>
            <Input
              placeholder="Tìm kiếm theo tên cột"
              className="rs-input"
              value={searchValue}
              onChange={e => setSearchValue(e.target.value)}
              allowClear
            />
          </div>

          <div className={`group-key ${groupOpen.group1 ? 'open' : ''}`} onClick={() => setGroupOpen({ ...groupOpen, group1: !groupOpen.group1 })}>
            <div className='icon'><CaretDownOutlined /></div>
            <div className='text'>Đang hiển thị</div>
          </div>
          <div className={`list-add-filter-content ${groupOpen.group1 ? '' : 'd-none'}`}>
            <DndContext
              sensors={sensors}
              collisionDetection={closestCenter}
              onDragEnd={handleDragEnd}
            >
              <SortableContext
                items={colDefs.map((item: any) => item.field.toString())}
                strategy={verticalListSortingStrategy}
              >
                <ul className="drag-drop-content customer-head-list-setting">
                  {colDefs.map((item: any, index: number) => (
                    <SortableItem
                      key={item.field}
                      item={item}
                      index={index}
                      colDefs={colDefs}
                      setColDefs={setColDefs}
                      filteredColDefs={filteredColDefs}
                      searchValue={searchValue}
                    />
                  ))}
                </ul>
              </SortableContext>
            </DndContext>
          </div>

          <div className={`group-key ${groupOpen.group2 ? 'open' : ''}`} onClick={() => setGroupOpen({ ...groupOpen, group2: !groupOpen.group2 })}>
            <div className='icon'><CaretDownOutlined /></div>
            <div className='text'>Không hiển thị</div>
          </div>
          <div className={`list-add-filter-content ${groupOpen.group2 ? '' : 'd-none'}`}>
            <ul className="drag-drop-content customer-head-list-setting">
              {colDefs.map((item: any, index: number) => (
                <li key={item.field} className={`one-op ${item.headerName === 'Hành động' || !item.hide ? 'd-none' : ''} ${searchValue ? filteredColDefs.some((x: any) => x.field === item.field) ? '' : 'hidden-x' : ''}`}>
                  <div className="text">
                    <Checkbox
                      className="one-add-filter-content"
                      checked={!item.hide}
                      onChange={(e: any) => {
                        const findData = colDefs.find((x: any) => x.field === item.field)
                        findData.hide = !e.target.checked
                        setColDefs([...colDefs])
                      }}
                    >
                      <div className="label">{item.headerName || 'check'}</div>
                    </Checkbox>
                  </div>
                </li>
              ))}
            </ul>
          </div>
        </div>
        <div className="footer-filter-block">
          <div className="btn-block">
            <div className="btn btn-primary btn-save-setting" onClick={() => {
              let temp = {} as any
              colDefs.map((val: any, index: any) => {
                temp[val.field] = {
                  ...val,
                  pos: index,
                }
                return true
              })
              stChange(colDefs, 'colDefs');
            }}>
              <div className="text">
                Lưu
              </div>
            </div>
          </div>
        </div>
      </div>
    </Drawer>
  );
};

export default ColSettingV2;
